/**
 *
 * Asynchronously loads the component for GuestLinkErrorPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GuestLinkErrorPage = lazyLoad(
  () => import('./index'),
  module => module.GuestLinkErrorPage,
);
